import '../../assets/components/ImageGallery/ImageGallery.css';//#region lib/components/ImageGallery/ImageGallery.module.css
var e = "_gallery_1xsea_1", t = "_frame_1xsea_7", n = "_clickable_1xsea_16", r = "_frameFullscreen_1xsea_20", i = "_image_1xsea_32", a = "_animate_1xsea_46", o = "_loader_1xsea_59", s = "_label_1xsea_67", c = "_arrow_1xsea_78", l = "_arrowLeft_1xsea_100", u = "_arrowRight_1xsea_104", d = "_expand_1xsea_108", f = "_close_1xsea_109", p = "_headerActions_1xsea_136", m = "_footer_1xsea_151", h = "_fullscreen_1xsea_163", g = {
	gallery: e,
	frame: t,
	clickable: n,
	frameFullscreen: r,
	image: i,
	animate: a,
	"gallery-fade": "_gallery-fade_1xsea_1",
	loader: o,
	label: s,
	arrow: c,
	arrowLeft: l,
	arrowRight: u,
	expand: d,
	close: f,
	headerActions: p,
	footer: m,
	fullscreen: h
};
//#endregion
export { a as animate, c as arrow, l as arrowLeft, u as arrowRight, n as clickable, f as close, g as default, d as expand, m as footer, t as frame, r as frameFullscreen, h as fullscreen, e as gallery, p as headerActions, i as image, s as label, o as loader };
